<template>
  <div id="login">
    <div class="login_box">
      <div class="login_cont">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p class="login_back login_active">登录</p>
            <p class="register_back" @click="goRegister">注册</p>
          </div>
          <div class="login_footer login">
            <input type="tel" placeholder="请输入用户名/手机号" v-model="loginName" maxlength="11">
            <input type="password" v-model="loginPass" placeholder="请输入登录密码">
            <input type="text" v-model="loginCode" placeholder="前请输入图形验证码">
            <s-identify
              class="picCode"
              :identifyCode="identifyCode"
              :contentWidth="97"
              :contentHeight="41"
              @refreshcode="getRePicCode"
            ></s-identify>
            <p class="login_p">
              <span class="left">
                <input type="checkbox" v-model="loginRememeber">记住用户名
              </span>
              <router-link class="right" to="/login/forgetpass" active-class="Active">忘记密码</router-link>
            </p>
            <button class="login_btn" @click="login">登录</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <div slot="header" class="clearfix">
              <span style="color: #E6A23C">用户登录</span>
            </div>
            <div class="content">
              <el-form ref="form">
                <el-form-item>
                  <el-input maxlength="11" v-model.number="loginName" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="loginPass" placeholder="请输入登录密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="loginCode" placeholder="请输入图形验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <s-identify :identifyCode="identifyCode" class="login_img"
                                  :contentWidth="150"
                                  :contentHeight="40"
                                  @refreshcode="getRePicCode"></s-identify>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item style="margin: 0">
                  <div>
                    <span class="auxiliary">
                      没有账户？
                      <router-link to="/login/register" class="red">
                      马上注册
                      </router-link>
                    </span>
                    <span class="auxiliary right">
                       <router-link class="red"  to="/login/forgetpass" active-class="Active">忘记密码?</router-link>
                    </span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" style="width: 100%" @click="login">登录</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import $ from "jquery";
import SIdentify from "../components/icode";
import md5 from 'js-md5';
import JSEncrypt from 'jsencrypt/bin/jsencrypt';
import { version } from "../../package";
export default {
  name: "Login",
  components: {
    SIdentify
  },
  activated() {
    var c = document.getElementById("canvas");
    var cxt = c.getContext("2d");
    c.height = c.height;
  },
  data() {
    return {
      loginName: localStorage.getItem("name") || "", //登录_账号
      loginPass: "", //登录_密码
      loginCode: "", //登录_验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      loginRememeber: localStorage.getItem("rememberName") || false //登录_记住密码 true：记住 false 不记住
    };
  },
  mounted: function() {
    this.isLogin();
    this.getRePicCode();
    let that = this;
    //监听回车事件
    document.onkeydown = function(e) {
      let kev = document.all ? window.event : e;
      if (kev.keyCode === 13) {
        that.login()
      }
    }
  },
  methods: {
    isLogin(){
      if (this.$store.state.loginType){
        this.$router.push({
          path: "/myaccount"
        });
      }
    },
    goRegister() {
      this.$router.push({
        path: "/login/register"
      });
    },
    //获取注册 图片验证码
    getRePicCode() {
      this.loginCode = "";
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //创建图形验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    loginService() {
            let accountNumber = localStorage.getItem("user_number");
            let password = localStorage.getItem("password");
            this
            .$http({
              url: this.$chatApiURL+"/api/user/login",
              method: "post",
              data: {
                account: accountNumber,
                password: md5(password)
              }
            })
            .then(function(res) {
              if(res.data.code==200){
                window.localStorage.chatToken = res.data.token;
              }
            });
  },
    login() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.loginName)) {
        that.$message.error("手机号格式不正确");
      } else if (that.loginPass == "") {
        that.$message.error("请输入登录密码");
      } else if (that.loginCode != that.identifyCode) {
        that.getRePicCode();
        that.$message.error("图片验证码不正确");
      } else {

        let publicKey = localStorage.getItem('encript_public_key')
        let userName = that.loginName.toString();
        let loginPhone = that.encryptMessage(userName,publicKey)
        let loginPassword = that.encryptMessage(that.loginPass,publicKey)

        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "login_e",
              phone: loginPhone,
              password: loginPassword,
              app_version: version
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              window.sessionStorage.setItem("loginType", true);
              let user_number = res.data.data.user_number;
              localStorage.setItem("user_number",user_number);
              localStorage.setItem("password",that.loginPass);
              that.$store.commit("changeLoginType", true);
              that.loginService();

              that.$router.push({
                path: "/myaccount"
              });
              window.sessionStorage.setItem("token", res.data.data.token);
              if (that.loginRememeber == true) {
                window.localStorage.setItem("name", that.loginName);
                window.localStorage.setItem("rememberName", true);
              } else {
                localStorage.removeItem("name");
                localStorage.removeItem("rememberName");
              }
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);       
   }
  },
  beforeDestroy() {
    document.onkeydown = function (e) {
      var key = document.all ? window.event : e;

      if (key.keyCode === 13) {

      }
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");
.picCode {
  display: inline-block;
  width: 97px;
  height: 41px;
  position: absolute;
  right: 78px;
  top: 248px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}
  .auxiliary{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue